import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import React, {
  useCallback,
  useMemo,
  useEffect,
  useState,
} from 'react';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';
import { useAcordoAladi } from '../../ts/common/hooks/useAcordoAladi.ts';

export default function QCXSelectAcordoAladiAutocomplete({
  label,
  name,
  initialValues,
  ...restProps
}) {
  const [defaultValue, setDefaultValue] = useState('');
  const { acordosAladi } = useAcordoAladi();

  const ACORDO_ALADI_LIST = useMemo(() => (
    acordosAladi.map((acordo) => ({
      label: `${acordo.code} - ${acordo.description}`,
      value: acordo.id,
    }))
  ), [acordosAladi]);

  useEffect(() => {
    const value = ACORDO_ALADI_LIST
      .find((item) => (
        item?.value === _.get(initialValues, name)
      ));

    if (value) {
      setDefaultValue(value);
    } else {
      setDefaultValue('');
    }
  }, [initialValues, ACORDO_ALADI_LIST]);

  const filterOptions = useMemo(() => (
    createFilterOptions({
      stringify: (option) => (
        option.label
      ),
    })
  ), []);

  const getOptionLabel = useCallback((item) => (
    item?.label || ''
  ), []);

  const getOptionValue = useCallback((item) => (
    item?.value || ''
  ), []);

  return (
    <QCXAutocompleteSelect
      label={label}
      id={name}
      name={name}
      options={ACORDO_ALADI_LIST}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      {...restProps}
    />
  );
}
